import {useLocale, useMessages} from "i18n";
import Seo from "../seo/Seo";
import {canonicalSiteUrl} from "../seo/siteMeta";
import {canonicalCurrencyCode, homeJsonLd} from "../seo/structuredData";

/** Home-route metadata; the App shell owns the persistent visible HomePage (ui#1061). */
export function Component() {
	const {canonicalLocale} = useLocale();
	const m = useMessages();
	// Home structured data: the Organization + WebSite + SoftwareApplication trio on the site this
	// document is canonical on (#1135) — the same one `<Seo>` canonicalizes on, so the entity `url`s and
	// the canonical can never name two different sites. Its free offer's CURRENCY comes from that same
	// canonical locale (#1136, replacing a hardcoded EUR that transferify.ro sells in none of), for the
	// identical reason and with the identical hydration properties — one argument, one origin, one
	// storefront. The advertised FEATURES stay in the reader's language, because they are the page's
	// visible claims rather than its identity.
	// The FAQPage lives on /features now (ui#110), where the FAQ is actually visible —
	// Google requires FAQPage markup to match FAQ content on the SAME URL, so it must NOT be emitted here.
	const jsonLd = homeJsonLd(canonicalSiteUrl(canonicalLocale), m.seo.softwareFeatureList,
		canonicalCurrencyCode(canonicalLocale));
	return (
		<Seo
			title={m.seo.home.title}
			description={m.seo.home.description}
			path="/"
			jsonLd={jsonLd}
		/>
	);
}
